import React, { useEffect, useState } from 'react';
import { IonText } from '@ionic/react';

// Generate random coins and notes for questions
const generateQuestion = () => {
    const items = ['₹1', '₹2', '₹5', '₹10', '₹20', '₹50', '₹100'];

    // Random grouping target (e.g., group into ₹30, ₹50, etc.)
    const groupTargetValue = (Math.floor(Math.random() * 4) + 1) * 30; // Random target between ₹30 and ₹120
    const groupTarget = `₹${groupTargetValue}`;

    // Generate a valid combination that sums up to the target
    const randomItems = getCombinationForTarget(groupTargetValue, items);

    // Add unnecessary items to the list (random items that don't contribute to the target)
    const unnecessaryItemsCount = Math.floor(Math.random() * 3) + 2; // Add 2 to 4 unnecessary items
    const allItems = [...randomItems];

    for (let i = 0; i < unnecessaryItemsCount; i++) {
        const randomItem = items[Math.floor(Math.random() * items.length)];
        allItems.push(randomItem); // Add unnecessary item to the list
    }

    // Shuffle the items array to mix the necessary and unnecessary items
    const shuffledItems = shuffleArray(allItems);

    return {
        randomItems: shuffledItems,
        groupTarget,
    };
};

// Function to generate a valid combination of items that sum to the target value
const getCombinationForTarget = (target: number, items: string[]): string[] => {
    const result: string[] = [];
    let remainingTarget = target;

    // Try to find a valid combination of items that sum to the target
    while (remainingTarget > 0) {
        const availableItems = items
            .map((item) => parseInt(item.replace('₹', ''), 10))
            .filter((itemValue) => itemValue <= remainingTarget);

        if (availableItems.length === 0) break; // If no available item fits

        const randomItemValue = availableItems[Math.floor(Math.random() * availableItems.length)];

        result.push(`₹${randomItemValue}`);
        remainingTarget -= randomItemValue;
    }

    return result;
};

// Function to shuffle the array of items (to mix the necessary and unnecessary items)
const shuffleArray = (array: string[]): string[] => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
    return array;
};

// Function to get all combinations using all items once, summing up to the target


const getAllCombinations = (items: string[], targetValue: number): number[] => {
    const result: number[] = [];
    const itemValues = items.map(item => parseInt(item.replace('₹', ''), 10));

    // Helper function to generate all unique combinations
    const findCombinations = (start: number, combination: number[], currentSum: number) => {
        if (currentSum === targetValue) {
            result.push(combination.length); // Push the length of the combination
            return;
        }
        if (currentSum > targetValue || start >= itemValues.length) {
            return;
        }

        for (let i = start; i < itemValues.length; i++) {
            // Include the current item in the combination
            findCombinations(i + 1, [...combination, itemValues[i]], currentSum + itemValues[i]);
        }
    };

    // Start the combination search
    findCombinations(0, [], 0);

    return result;
};


// Calculate the number of bundles required to meet the target
const calculateGroupItems = (randomItems: string[], groupTarget: string) => {
    const targetValue = parseInt(groupTarget.replace('₹', ''), 10);  // Convert ₹ target to numeric value

    // Get all valid combinations
    const validCombinations = getAllCombinations(randomItems, targetValue);

    // Return the number of valid combinations (i.e., how many ways the items can sum exactly to the target)
    return validCombinations;
};

interface QuestionData {
    randomItems: string[];
    groupTarget: string;
}

const SortingGrouping: React.FC = () => {
    const [question, setQuestion] = useState<QuestionData>({
        randomItems: [],
        groupTarget: '',
    });
    const [userAnswer, setUserAnswer] = useState('');
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);

    const handleSubmit = () => {
        const correctAnswer = calculateGroupItems(question.randomItems, question.groupTarget);
        const userAnswerValue = parseInt(userAnswer, 10);

        console.log(correctAnswer)

        if (correctAnswer.includes(userAnswerValue)) {
            setShowImage(true);
            setTimeout(() => {
                generateNewQuestion();
                setUserAnswer('');
                setShowImage(false);
                setError(false);
            }, 5000); // Delay before generating a new question
        } else {
            setError(true);
        }
    };

    const generateNewQuestion = () => {
        const newQuestion = generateQuestion();
        setQuestion(newQuestion);
        setUserAnswer('');
        setError(false);
    };

    useEffect(() => {
        generateNewQuestion(); // Generate question when the component mounts
        document.title = "Mamas Guidance - Class Two - Mathematics - Money - Sorting & Grouping"; // Set page title
    }, []);

    return (
        <>
            {showImage === false ? (
                <div className="contentPart showCenter additionWord">
                    <div>
                        <h2>Question</h2>
                        <p>
                            Sort and group the following items into bundles of <b>{question.groupTarget}</b>:
                        </p>
                        <IonText>{question.randomItems.join(', ')}</IonText>
                        <h2>Your Answer</h2>
                        <p>How many items are in one group of <b>{question.groupTarget}</b>?</p>
                        <div className='mb-4'>
                            <input
                                type="number"
                                value={userAnswer}
                                onChange={(e) => setUserAnswer(e.target.value)}
                                placeholder="Enter your answer"
                                className={`form-control blank-input ${error == true  ? 'error' : ''} `}
                            />
                        </div>
                        <div className="text-center">
                            <div className="optionButton" onClick={handleSubmit}>
                                Submit
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: '150px' }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK}
                    />
                </div>
            )}
        </>
    );
};

export default SortingGrouping;
